import React from 'react'

import actions from 'actions'
import { connect } from 'react-redux'

import { storeSelectedIngredients } from 'actions/getHelp'

import {
  trackDeselectIngredient,
  trackSelectIngredient,
  validateLatestOrder,
} from '../actions/getHelp'
import { validateSelectedIngredients } from '../actions/validateSelectedIngredients'
import {
  getIsBoxDailyComplaintLimitReached,
  getIsMultiComplaintLimitReachedLastFourWeeks,
  getIsOrderValidationError,
  getIsOrderValidationPending,
} from '../selectors/orderSelectors'
import { getRecipes } from '../selectors/recipesSelectors'
import { getMassIssueIneligibleIngrsByRecipeGRMap, getOrder } from '../selectors/selectors'
import { Ingredients } from './Ingredients.logic'

const mapStateToProps = (state) => ({
  massIssueIneligibleIngrsByRecipeGRMap: getMassIssueIneligibleIngrsByRecipeGRMap(state),
  isOrderValidationError: getIsOrderValidationError(state),
  isMultiComplaintLimitReachedLastFourWeeks: getIsMultiComplaintLimitReachedLastFourWeeks(state),
  isBoxDailyComplaintLimitReached: getIsBoxDailyComplaintLimitReached(state),
  isValidateOrderLoading: getIsOrderValidationPending(state),
  order: getOrder(state),
  recipes: getRecipes(state),
  user: {
    id: state.user.get('id'),
    accessToken: state.auth.get('accessToken'),
  },
})

const IngredientsContainer = connect(mapStateToProps, {
  storeSelectedIngredients,
  trackDeselectIngredient,
  trackSelectIngredient,
  validateLatestOrder,
  validateSelectedIngredients,
  userLoadData: actions.userLoadData,
  // eslint-disable-next-line react/jsx-props-no-spreading
})((props) => <Ingredients {...props} routeParams={props.params} />)

export { IngredientsContainer }
